import { PlanTypes } from 'mbs-ui-shared@models/PlanTypes.enum';
import { BaseSQLPlanModel } from 'wizards/models/base-sql-plan-model';
import { BackupPlan } from 'wizards/models/base/backup-plan-model';
import { BaseHyperVPlanModel } from 'wizards/models/base/base-hyper-v-plan-model';
import { BaseRestoreVMPlan } from 'wizards/models/base/base-restore-vm-plan';
import { BaseVMWarePlanModel } from 'wizards/models/base/base-vmware-plan-model';
import { BackupDiskImagePlan } from 'wizards/models/base/ibb-plan-model';
import { RestoreIbbBase } from 'wizards/models/base/restore-ibb-base-model';
import { RestorePlan } from 'wizards/models/base/restore-plan-model';

export type BasePlanType =
  | BackupPlan
  | BackupDiskImagePlan
  | RestorePlan
  | RestoreIbbBase
  | BaseHyperVPlanModel
  | BaseRestoreVMPlan
  | BaseVMWarePlanModel
  | BaseSQLPlanModel;

export function getBasePlanFromType(planType: PlanTypes): BasePlanType {
  switch (planType) {
    case PlanTypes.Plan:
      return new BackupPlan();
    case PlanTypes.BackupDiskImagePlan:
      return new BackupDiskImagePlan();
    case PlanTypes.RestorePlan:
      return new RestorePlan();
    case PlanTypes.RestoreDiskImagePlan:
      return new RestoreIbbBase();
    case PlanTypes.BackupHyperV:
      return new BaseHyperVPlanModel();
    case PlanTypes.RestoreHyperV:
      return new BaseRestoreVMPlan();
    case PlanTypes.BackupVMware:
      return new BaseVMWarePlanModel();
    case PlanTypes.RestoreVMware:
      return new BaseRestoreVMPlan();
    case PlanTypes.DataBasePlan:
      return new BaseSQLPlanModel();
    default:
      return new BackupPlan();
  }
}
